jQuery(function ($) {
  $("#cur_location").on("click", ".loca_pop_close", function () {
    $(this).parents("#cur_location.on").removeClass("on");
    });
    
        var cur_loca_selected = $('select#ch_location_select option:checked').val();
    console.log('cur_loca_selected'+cur_loca_selected);
    if(cur_loca_selected = 'US'){
      $('.selected_flag').append("<img src='https://cdn.shopify.com/shopifycloud/web/assets/v1/7f0109d94c888a663452af48e2d324d7.svg'/>");
      $('.loca_currency').html('USD');
    $('.aviation_warn li.us_warn.hide').show();
    $('.aviation_warn li.common_warn').hide();
    }
  

})
  
    function chageLocationSelect(){
    var langSelect = document.getElementById("ch_location_select");
    var selectValue = langSelect.options[langSelect.selectedIndex].value;
    var selectText = langSelect.options[langSelect.selectedIndex].text;
    console.log(selectValue);
    $('.hide').hide();
    $('.aviation_warn li.common_warn').show();
    if(selectValue  == 'US'){
      $('.selected_flag').append("<img src='https://cdn.shopify.com/shopifycloud/web/assets/v1/7f0109d94c888a663452af48e2d324d7.svg'/>");
      $('.loca_currency').html('USD');
    $('.aviation_warn li.us_warn.hide').show();
    $('.aviation_warn li.common_warn').hide();
    }if(selectValue  == 'AE'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/62a4257f72ece1437bc8eb7f0535327b.svg"/>');
      $('.loca_currency').html('AED');
      
    }if(selectValue  == 'AU'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/d4e9cde3edb3e1732ec50170e158d750.svg"/>');
      $('.loca_currency').html('AUD');
    }if(selectValue  == 'BR'){
      $('.selected_flag').append("<img src='https://cdn.shopify.com/shopifycloud/web/assets/v1/190073fb7652e7c635a1b91af0286b3c.svg'/>");
      $('.loca_currency').html('BRL');
    }if(selectValue  == 'CA'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/422898ab4299eb270f856e6c1b8d2250.svg"/>');
      $('.loca_currency').html('CAD');
    }if(selectValue  == 'CH'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/a5d4c82835e435ecff150a9a3426fed2.svg"/>');
      $('.loca_currency').html('CHF');
    } if(selectValue  == 'DK'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/e60c493fdbe69069d943ecc37287aa90.svg"/>');
      $('.loca_currency').html('DKK');
    }  if(selectValue  == 'GB'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/f9bbc4885a348eff84e4ef4155121fae.svg"/>');
      $('.loca_currency').html('GBP');
    }if(selectValue  == 'MX'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/2bcda95713919c2134876a7da635da80.svg"/>');
      $('.loca_currency').html('MXN');
    $('.aviation_warn li.mx_warn.hide').show();
    }if(selectValue  == 'NO'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/d8dd9ad33e2d0c876096fbdfd87bcf31.svg"/>');
      $('.loca_currency').html('NOK');
    }if(selectValue  == 'NZ'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/cacb9f87701ae2707676064d036a97b2.svg"/>');
      $('.loca_currency').html('NZD');
    }if(selectValue  == 'PT'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/9886b4168efb1ebf48006093aa9807c5.svg"/>');
      $('.loca_currency').html('PLN');
    }if(selectValue  == 'SE'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/637920f30b717c7f4e826a4bb63bb552.svg"/>');
      $('.loca_currency').html('SEK');
    }
    
    if(selectValue  == 'DE'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/9886b4168efb1ebf48006093aa9807c5.svg"/>');
      $('.loca_currency').html('EUR');
    }if(selectValue  == 'AT'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/9886b4168efb1ebf48006093aa9807c5.svg"/>');
      $('.loca_currency').html('EUR');
    }if(selectValue  == 'BE'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/9886b4168efb1ebf48006093aa9807c5.svg"/>');
      $('.loca_currency').html('EUR');
    }if(selectValue  == 'FI'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/9886b4168efb1ebf48006093aa9807c5.svg"/>');
      $('.loca_currency').html('EUR');
    }if(selectValue  == 'FR'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/9886b4168efb1ebf48006093aa9807c5.svg"/>');
      $('.loca_currency').html('EUR');
    }if(selectValue  == 'GR'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/9886b4168efb1ebf48006093aa9807c5.svg"/>');
      $('.loca_currency').html('EUR');
    }if(selectValue  == 'IE'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/9886b4168efb1ebf48006093aa9807c5.svg"/>');
      $('.loca_currency').html('EUR');
    }if(selectValue  == 'IT'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/9886b4168efb1ebf48006093aa9807c5.svg"/>');
      $('.loca_currency').html('EUR');
    }if(selectValue  == 'NL'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/9886b4168efb1ebf48006093aa9807c5.svg"/>');
      $('.loca_currency').html('EUR');
    }if(selectValue == 'PL'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/965125896e906dc4ccbf65fa398c386c.svg"/>');
      $('.loca_currency').html('POL');
    }if(selectValue == 'AE'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/62a4257f72ece1437bc8eb7f0535327b.svg"/>');
      $('.loca_currency').html('AED');
    }if(selectValue  == 'ES'){
      $(".selected_flag").append('<img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/9886b4168efb1ebf48006093aa9807c5.svg"/>');
      $('.loca_currency').html('EUR');
    $('.aviation_warn li.sp_warn.hide').show();
    }else{
    
    }
    
    
    
    
    }